import request from '@/utils/request'

/** 组织列表：系统管理员返回全部，组织管理员只返回自己的组织 */
export function listOrgs() {
    return request({ url: '/admin/org/list', method: 'get' })
}

/** 当前用户所属组织（未归属组织时 data 为 null） */
export function getMyOrg() {
    return request({ url: '/admin/org/mine', method: 'get' })
}

export function getOrg(orgId) {
    return request({ url: '/admin/org/' + orgId, method: 'get' })
}

export function addOrg(data) {
    return request({ url: '/admin/org', method: 'post', data })
}

export function updateOrg(data) {
    return request({ url: '/admin/org', method: 'put', data })
}

export function updateOrgStatus(orgId, status) {
    return request({ url: '/admin/org/' + orgId + '/status', method: 'put', params: { status } })
}

/** 整体设置管理员：传 userIds，空数组会被后端拒绝 */
export function setOrgAdmins(orgId, userIds) {
    return request({ url: '/admin/org/' + orgId + '/admins', method: 'put', data: { userIds } })
}

export function uploadOrgLogo(orgId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: '/admin/org/' + orgId + '/logo',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

/** 成员分页：params = { keyword, role, status, current, size } */
export function listOrgMembers(orgId, params) {
    return request({ url: '/admin/org/' + orgId + '/members', method: 'get', params })
}

export function addOrgMember(orgId, data) {
    return request({ url: '/admin/org/' + orgId + '/members', method: 'post', data })
}

export function updateOrgMember(orgId, userId, data) {
    return request({ url: '/admin/org/' + orgId + '/members/' + userId, method: 'put', data })
}

/** 批量调整组织内角色：data = { userIds, role: 'admin' | 'researcher' } */
export function setOrgMemberRole(orgId, data) {
    return request({ url: '/admin/org/' + orgId + '/members/role', method: 'put', data })
}

export function removeOrgMembers(orgId, userIds) {
    return request({ url: '/admin/org/' + orgId + '/members', method: 'delete', data: userIds })
}
